import React, { Fragment } from "react";
import Header from "../../components/header";
import ViewBidsContainer from "../../containers/autionDataList/viewBidsContainer";

const ViewBidsPage = () => {

	return (
		<Fragment>
			<Header>
				<Header.MaxWidth>
					<Header.Logo
						src="../../../../../assets/title/Tractor world Logo.svg"
						alt="Logo"
					/>
				</Header.MaxWidth>
			</Header>
            <ViewBidsContainer />
		</Fragment>
	);
};

export default ViewBidsPage;
